export const read = (key: string) => {
  const data = localStorage.getItem(key);
  return data;
};

export const readObj = (key: string) => {
  const data = localStorage.getItem(key);
  if (data) {
    return JSON.parse(data);
  }
};

export const write = (key: string, value: string | object) => {
  if (typeof value === "object") {
    value = JSON.stringify(value);
  }
  localStorage.setItem(key, value);
};

export const clear = (key: string) => localStorage.removeItem(key);

export const clearAll = () => localStorage.clear();
export const setCookie = (name: string, value: any, days: number): void => {
  if (typeof document === "undefined") return;

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  const stringValue: string =
    typeof value !== "string" ? JSON.stringify(value) : value;

  const encodedValue = encodeURIComponent(stringValue);
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    document.cookie = `${name}=${encodedValue};expires=${expires.toUTCString()};path=/;Secure;SameSite=Lax`;
  } else {
    document.cookie = `${name}=${encodedValue};expires=${expires.toUTCString()};domain=.easyfleet.ai;path=/;Secure;SameSite=Lax`;
  }
};
export const getCookie = <T = string | object>(name: string): T | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    const cookieValue = parts.pop()!.split(";").shift()!;
    const decodedValue = decodeURIComponent(cookieValue);

    try {
      return JSON.parse(decodedValue) as T;
    } catch (e) {
      return decodedValue as T extends string ? T : never;
    }
  }
  return null;
};
export const removeAllCookies = (): void => {
  const cookies = document.cookie.split(";");

  cookies.forEach((cookie) => {
    const cookieName = cookie.split("=")[0].trim();

    if (cookieName) {
      const expires = new Date(0).toUTCString();
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        document.cookie = `${cookieName}=;expires=${expires};path=/;Secure;SameSite=Lax`;
      } else {
        document.cookie = `${cookieName}=;expires=${expires};domain=.easyfleet.ai;path=/;Secure;SameSite=Lax`;
      }
    }
  });
};
